<template>
    <div class="keyword-prompt">
        <img src="/img/3dmap/search.png" class="anticon-search" @click="searchHandle">
        <img src="/img/3dmap/close.png" class="anticon-close" @click="clearHandle" v-if="show">
        <input type="text" id="suggestId" v-model="keyWord"/>
        <div id="searchResultPanel" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
    </div>
</template>
<script>
export default {
    name:'keyPrompt',
    data(){
        return{
            keyWord:'',
            show:false,
        }
    },
    watch:{
        keyWord:function(){
            this.show=this.keyWord?true:false;
        }
    },
    props:['map'],
    methods:{
        searchHandle(){
            console.log(this.keyWord)
            this.addressAnalysis(this.keyWord);
        },
        clearHandle(){
            if(this.keyWord){
                this.keyWord='';
            }
        },
        G(id){
            return document.getElementById(id);
        },
        // 地址解析 关键字转坐标
        addressAnalysis(key){
            // 创建地址解析器实例
            var myGeo = new BMap.Geocoder();
            myGeo.getPoint(key, (point)=>{
                if (point) {
                    this.$emit('pointRes',point,key);
                }else{
                    console.log("您选择地址没有解析到结果!");
                }
            });
        },
        // 关键字输入提示
        searchPrompt(){
            let ac = new BMap.Autocomplete({ // 创建一个自动完成对象
                "input" : "suggestId",
                "location" :this.map
            });
            ac.setInputValue(this.keyWord);//保存输入框里输入的值
            ac.addEventListener("onhighlight", (e)=> { //鼠标放在下拉列表上的事件
                var str = "";
                var _value = e.fromitem.value;
                var value = "";
                if (e.fromitem.index > -1) {
                    value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                }
                str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;
                value = "";
                if (e.toitem.index > -1) {
                    _value = e.toitem.value;
                    value = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                }
                str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
                this.G("searchResultPanel").innerHTML = str;
            })
            var myValue;
            ac.addEventListener("onconfirm", (e)=> { //鼠标点击下拉列表后的事件
                var _value = e.item.value;
                myValue = _value.province +  _value.city +  _value.district +  _value.street +  _value.business;
                this.G("searchResultPanel").innerHTML ="onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
                this.myValue=myValue;
                console.log(this.myValue)
                this.addressAnalysis(myValue);
            })

        }
    },
    mounted(){
        this.searchPrompt();
    }

}
</script>
<style lang="scss" scoped>
.keyword-prompt{
    position: relative;
    .anticon-search{
        cursor: pointer;
        position:absolute;
        left:6px;
        top:10px;
        width:16px;
        height:16px;
    }
    .anticon-close{
        position:absolute;
        width:12px;
        height:12px;
        right:6px;
        top:10px;
        font-size: 12px;
        cursor: pointer;
    }
    #suggestId{
        width:320px;
        height:32px;
        padding-left:30px;
        padding-right:25px;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
    }
    #suggestId:focus{
        border:1px solid #40a9ff;
        box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
}
</style>


